export const getAlentejoData = () => ({
  name: "Alentejo",
  country: "Portugal",
  description: "L'Alentejo est la grande région viticole du sud du Portugal, réputée pour ses rouges généreux, ses blancs aromatiques et ses paysages de plaines dorées.",
  type: "region",
  subregions: [
    { name: "Alentejo Central", area: "8,000 ha", percentage: "36%", description: "Cœur de la production régionale" },
    { name: "Borba", area: "3,000 ha", percentage: "14%", description: "Vins élégants et fruités" },
    { name: "Évora", area: "2,500 ha", percentage: "11%", description: "Vins de terroir" },
    { name: "Redondo", area: "2,000 ha", percentage: "9%", description: "Vins souples et ronds" },
    { name: "Reguengos", area: "2,500 ha", percentage: "11%", description: "Vins puissants" },
    { name: "Vidigueira", area: "2,000 ha", percentage: "9%", description: "Vins blancs frais" },
    { name: "Portalegre", area: "2,000 ha", percentage: "9%", description: "Vins de montagne" }
  ],
  mapAreas: [
    { region: "Alentejo Central", x: 56, y: 66, color: "#4B164C", size: 6 },
    { region: "Borba", x: 58, y: 64, color: "#6d2c7a", size: 4 },
    { region: "Évora", x: 54, y: 68, color: "#8a4a8a", size: 3 },
    { region: "Redondo", x: 60, y: 68, color: "#a768a6", size: 3 },
    { region: "Reguengos", x: 62, y: 70, color: "#c486c4", size: 3 },
    { region: "Vidigueira", x: 64, y: 72, color: "#e2a4e2", size: 3 },
    { region: "Portalegre", x: 52, y: 62, color: "#f0c2f0", size: 3 }
  ],
  statistics: {
    totalArea: "22,000 ha",
    production: "700,000 hl",
    wineries: "90+ domaines",
    appellations: "7 sous-régions",
    exportPercentage: "35%"
  },
  characteristics: {
    climate: "Climat méditerranéen chaud, étés très secs",
    soil: "Sols argilo-calcaires, schistes, granits",
    viticulture: "Vignes en plaine, vendanges précoces, cépages autochtones et internationaux"
  },
  wineStyles: {
    red: "Rouges généreux, souples, fruités, souvent à base d'Aragonez et Trincadeira",
    white: "Blancs aromatiques, frais, à base d'Antão Vaz et Arinto"
  },
  history: "L'Alentejo a connu un renouveau viticole depuis les années 1980, devenant une région phare du Portugal moderne.",
  foodPairing: "Porc noir ibérique, fromages de brebis, plats mijotés, cuisine de l'Alentejo"
}); 